
import { useCallback } from 'react';

export function useValidImageUrl() {
  // Check if the URL is valid and accessible
  const isValidImageUrl = useCallback((url: string | null): boolean => {
    if (!url) return false;
    
    // Data URLs are valid but may indicate other issues
    if (url.startsWith('data:')) return true;
    
    // Check if URL is properly formed
    try {
      new URL(url);
      return true;
    } catch (e) {
      console.error('Invalid URL format:', url);
      return false;
    }
  }, []);

  return { isValidImageUrl };
}
